import shallow from 'zustand/shallow';

import { useDialog, useSnack } from '@/logic/state';
import { ConfirmDialog } from '../shared/confirm-dialog';
import { useDeleteVoucher } from '@/logic/services';
import { FC } from 'react';

const deleteVoucherImg = '/icons/profile/deletePopup.svg';

export const DeleteVoucherConfirmDialog: FC = () => {
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const setSnack = useSnack(s => s.setSnack, shallow);

  const { mutate: deleteVoucher, isLoading: isDeletingVoucher } = useDeleteVoucher(
    {},
    {
      onSuccess: res => {
        setSnack({
          isOpen: true,
          message: 'voucher.delete.success',
          type: 'success',
        });

        dialog?.deleteVoucherConfirmDialogPayload?.handleSuccess(res);
        setDialog({});
      },
      onError: () => {
        setSnack({
          isOpen: true,
          message: 'global.error',
          type: 'error',
        });
      },
    }
  );

  const handleDeleteVoucher = () => {
    deleteVoucher({
      query: {
        orderId: dialog?.deleteVoucherConfirmDialogPayload?.orderId,
      },
      params: {
        barCode: dialog?.deleteVoucherConfirmDialogPayload?.barCode,
      },
    });
  };

  return (
    <ConfirmDialog
      buttonId='voucher.delete'
      img={deleteVoucherImg}
      widthImage='99px'
      heightImage='106px'
      altImage='alt.delete_voucher_icon'
      title='voucher.delete.confirm.title'
      description='voucher.delete.confirm.description'
      handleOkayClick={handleDeleteVoucher}
      handleCloseClick={() => setDialog({})}
      isLoading={isDeletingVoucher}
    />
  );
};
